export const SET_DAY = "SET_DAY";
export const SET_SUBJECT = "SET_SUBJECT";
export const SET_QUESTIONS_LIST = "SET_QUESTIONS_LIST";
export const SET_PYQ_TESTS_RESULT_DATA = "SET_PYQ_TESTS_RESULT_DATA";